export default {
  'component.globalHeader.theme.switchToLight': '浅色',
  'component.globalHeader.theme.switchToDark': '深色',
};
